import { useCallback, useEffect, useState } from 'react';

import bumperMark from 'images/bumperMcp/bumper-mark.png';

import { ConnectSection } from './components/ConnectSection';
import { HeroSection } from './components/HeroSection';
import {
  PageHeader,
  PageIcon,
  PageRoot,
  PageTitle,
} from './components/styledComponents';

export const McpPage = () => {
  const [isSetupVisible, setIsSetupVisible] = useState(false);

  useEffect(() => {
    document.title = 'MCP - Bumper';
  }, []);

  const handleGetStartedClick = useCallback(() => setIsSetupVisible(true), []);
  const handleBackClick = useCallback(() => setIsSetupVisible(false), []);

  return (
    <PageRoot>
      <PageHeader>
        <PageIcon src={bumperMark} alt="" />
        <PageTitle>MCP</PageTitle>
      </PageHeader>
      {isSetupVisible ? (
        <ConnectSection onBackClick={handleBackClick} />
      ) : (
        <HeroSection onGetStartedClick={handleGetStartedClick} />
      )}
    </PageRoot>
  );
};
